"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ListItem = exports["default"] = /*#__PURE__*/function (_Component) {
  function ListItem() {
    var _this;
    (0, _classCallCheck2["default"])(this, ListItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ListItem, [].concat(args));
    (0, _defineProperty2["default"])(_this, "generateDjs", function () {
      var _this$props$item = _this.props.item,
        _this$props$item$head = _this$props$item.headlineDj,
        headlineDj = _this$props$item$head === void 0 ? {} : _this$props$item$head,
        _this$props$item$resi = _this$props$item.residentDjs,
        residentDjs = _this$props$item$resi === void 0 ? [] : _this$props$item$resi;
      var HeadlineDj;
      var ResidentDjs;
      if (headlineDj.name) {
        HeadlineDj = function HeadlineDj() {
          return /*#__PURE__*/_react["default"].createElement("a", {
            href: headlineDj.link
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "headline-dj text-bold"
          }, headlineDj.name));
        };
      }
      if (residentDjs) {
        ResidentDjs = function ResidentDjs() {
          return residentDjs.map(function (dj, i) {
            return dj.name !== '' && /*#__PURE__*/_react["default"].createElement("a", {
              key: JSON.stringify(dj),
              href: dj.link
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "resident-dj"
            }, i !== 0 && ', ', dj.name));
          });
        };
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb10"
      }, HeadlineDj && /*#__PURE__*/_react["default"].createElement(HeadlineDj, null), headlineDj.name && residentDjs && /*#__PURE__*/_react["default"].createElement("span", null, ", "), ResidentDjs && /*#__PURE__*/_react["default"].createElement(ResidentDjs, null));
    });
    return _this;
  }
  (0, _inherits2["default"])(ListItem, _Component);
  return (0, _createClass2["default"])(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        item = _this$props.item,
        activeWeek = _this$props.activeWeek;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "fwl-list__list-item"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "item-left"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-md"
      }, item.destination), this.generateDjs(), /*#__PURE__*/_react["default"].createElement("span", {
        className: "date"
      }, "Week ", activeWeek, ", ", item.beginDate, " - ", item.endDate)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "item-right"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: item.destinationSlug,
        className: "btn btn-secondary"
      }, "View")));
    }
  }]);
}(_react.Component);
(0, _defineProperty2["default"])(ListItem, "propTypes", {
  item: _propTypes["default"].object.isRequired,
  activeWeek: _propTypes["default"].string.isRequired
});